import 'vue-fast-marquee/style.css'
import '@blibli/dls/dist/blue.min.css'
import './assets/css/main.scss'
import '@api-mock'
import '@blibli/blue-dls-utils/dist/scss/_box-sizing-helper.scss'
import '@blibli/blue-font/dist/_blue-font-blibli.scss'

import { createApp } from 'vue'
import Marquee from 'vue-fast-marquee'
import VueScrollTo from 'vue-scrollto'

import App from '@/App.vue'
import router from '@/router'

import pinia from './store/init'

const app = createApp(App)

app.use(router)
app.use(pinia)
app.use(VueScrollTo)
app.use(Marquee)

app.mount('#app')
